import { BaseModel } from "@blue-chip/core";

export default class File extends BaseModel {}
